import Vue from 'vue';
var moment = require("moment");
const FORMAT_DATE_IT = "DD-MM-YYYY";

function getDateInstance(value) {
	if(value instanceof Date)
		return value;

	if(typeof value === 'string') {
		return new Date(value);
	}

	if(typeof value === 'number') {
		const date = new Date();
		date.setTime(value);
		return date;
	}
}

Vue.filter('capitalize', function(value) {
	if (!value) return '';
	value = value.toString().toLowerCase();
	return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter('uppercase', function(value) {
	if (!value) return '';
	value = value.toString();
	return value.toUpperCase();
});

Vue.filter('lowercase', function(value) {
	if (!value) return '';
	value = value.toString();
	return value.toLowerCase();
});

Vue.filter('date', function(value) {
	if (!value) return '--';
	return moment(value).format(FORMAT_DATE_IT);
	//const date = getDateInstance(value);
	//const string = date.toISOString();
	//return string.split("T")[0];
});

Vue.filter('datetime', function(value) {
	if (!value) return '';
	const date = getDateInstance(value);
	const string = date.toISOString();
	const dt = string.split(/[T\.]/);
	return dt[0] + " " + dt[1];
});

Vue.filter('timedate', function(value, timezoneConverted = false) {
	if (!value) return '';
	let date = getDateInstance(value);
	if(timezoneConverted) {
		// Note that getTimezoneOffset returns the offest in *minutes*
		date.setTime(date.getTime() - (date.getTimezoneOffset() * 60 * 1000));
	}
	const string = date.toISOString();
	const dt = string.split(/[T\.]/);
	return dt[1] + " (" + dt[0] + ")";
});

Vue.filter('time', function(value) {
	if (!value) return '';
	const date = getDateInstance(value);
	const string = date.toISOString();
	const dt = string.split(/[T\.]/);
	return dt[1];
});

Vue.filter('percentage', function(value) {
	if (!value || !value instanceof Number) return 'NA';
	return (value * 100).toFixed(2);
});

Vue.prototype.$filters = Vue.options.filters